const status = {
  ENABLED: 'ENABLED',
  SUSPENDED: 'SUSPENDED'
}

export default status
